import { ChangeDetectorRef, Component } from '@angular/core';
import { SeConstraintNotifierService } from '@se/se.platform.base';
import { GraphAxisType } from '@se/cp.common';
import { fromServerIsoString } from '@se/platform';
import { Logger } from '@se/se.platform.base';
import { isMoment } from 'moment';
import { takeUntil } from 'rxjs/operators';
import { ICpEntity, PropertyType } from '../../cp-configuration/view-model';
import { CpGraphControl } from '../../cp-configuration/view-model/cp-graph-control';
import { CpModelService } from '../../cp-model.service';
import { AbstractControlComponent } from '../abstract-control';

@Component({
    selector: 'cp-graph',
    templateUrl: './graph.component.html',
    styleUrls: ['./graph.component.scss'],
    standalone: false
})
export class CpGraphComponent extends AbstractControlComponent {
    control!: CpGraphControl;

    data: any[][] = [];

    constructor(
        private modelService: CpModelService,
        cdr: ChangeDetectorRef,
        constraintNotifierService: SeConstraintNotifierService,
        logger: Logger
    ) {
        super(cdr, constraintNotifierService, logger);
    }

    onFocus() {
        this.focusin.emit();
    }

    // Solo lettura dati
    onModelChange(_: unknown) {
        return false;
    }

    protected init() {
        this.control
            .getModelObservable(this.modelService)
            .pipe(takeUntil(this.destroyed$))
            .subscribe((model) => {
                this.logger && this.logger.trace(`Model update ${this.control.name} ${model}`);
                this.updateGraph(model?.activeEntities);
            });
    }

    private updateGraph(model: ICpEntity[] | undefined) {
        this.data = [];

        if (model) {
            this.data.push(
                model.map((e) => ({
                    [this.control.x.prop]: this.convertAxisValue(
                        this.control.x.type,
                        e.getPropertyValue(this.control.x.prop)
                    ),
                    [this.control.y.prop]: this.convertAxisValue(
                        this.control.x.type,
                        e.getPropertyValue(this.control.y.prop)
                    ),
                }))
            );
        }
    }

    private convertAxisValue(type: GraphAxisType, prop: PropertyType) {
        if (type === 'number') {
            return prop;
        }
        if (type === 'date') {
            if (isMoment(prop)) {
                return prop.toDate();
            }
            if (typeof prop === 'string') {
                return fromServerIsoString(prop).toDate();
            }
            return prop;
        }
    }
}
